module.exports = __webpack_public_path__ + "img/16l005-07.45e74e4d.png";